import { Icon } from '@iconify/react';
import { Box, Stack, TableCell, TableRow, Typography } from '@mui/material';
import { format } from 'date-fns';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Schema } from '../../../../../amplify/data/resource';
import LoadingIcon from '../../../../components/activeIcons/LoadingIcon';
import AgentIcon from '../../../../components/icons/AgentIcon';
import ResetIcon from '../../../../components/icons/ResetIcon';
import Edit from './Edit';

// @ts-ignore
type Agent = Schema['User']['type'];

const Item = ({ agent }: { agent: Agent }) => {
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);

  return (
    <>
      <TableRow
        sx={{
          backgroundColor: '#F2F4F7',
          borderRadius: '10px',
          '&:last-child td, &:last-child th': { border: 0 },
          boxShadow: 'none',
        }}
      >
        <TableCell
          sx={{
            padding: '20px',
            borderBottom: 'none',
            borderTopRightRadius: '10px',
            borderBottomRightRadius: '10px',
            textAlign: 'right',
            width: '170px',
          }}
        >
          <Stack direction="row" alignItems="center" gap={1}>
            <AgentIcon />
            <Stack>
              <Typography
                fontSize="14px"
                fontWeight="700"
                fontFamily={'AlmoniDL'}
              >
                {agent.fullName}
              </Typography>
              <Typography
                fontSize="14px"
                fontWeight="700"
                fontFamily={'AlmoniDL'}
              >
                {agent.agentId}
              </Typography>
            </Stack>
          </Stack>
        </TableCell>
        <TableCell
          sx={{
            padding: '20px',
            borderBottom: 'none',
            textAlign: 'right',
            width: '190px',
          }}
        >
          <Stack
            direction="row"
            justifyContent={'space-between'}
            sx={{
              background: '#FFF',
              p: '7px',
              borderRadius: '10px',
              height: '35px',
            }}
          >
            <Stack direction="row-reverse" gap={2}>
              <Stack direction="row-reverse" alignItems="center" gap={1}>
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  {agent.phone}
                </Typography>
                <LoadingIcon loading={true} />
              </Stack>
              <Stack direction="row-reverse" alignItems="center" gap={1}>
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  {agent.email}
                </Typography>
                <LoadingIcon loading={true} />
              </Stack>
            </Stack>
            <img
              alt="logo"
              src={'/assets/client/send.svg'}
              style={{ cursor: 'pointer' }}
            />
          </Stack>
        </TableCell>
        <TableCell
          sx={{
            width: '80px',
            padding: '20px',
            borderBottom: 'none',
            textAlign: 'right',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography fontSize="14px" fontWeight="700" fontFamily={'AlmoniDL'}>
            {agent.createdAt
              ? format(new Date(agent.createdAt), 'yyyy-dd-MM')
              : 'N/A'}
          </Typography>
        </TableCell>

        <TableCell
          sx={{
            width: '200px',
            padding: '20px',
            borderBottom: 'none',
            borderTopLeftRadius: '10px',
            borderBottomLeftRadius: '10px',
          }}
        >
          <Stack direction="row-reverse" gap={1.5}>
            <Box
              sx={{
                background: '#FFF',
                width: '40px',
                height: '40px',
                borderRadius: '10px',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                cursor: 'pointer',
              }}
              onClick={() => {
                navigate(`/agent/${agent.id}`);
              }}
            >
              <Icon
                icon="basil:invoice-solid"
                color="#424245"
                width="25px"
                style={{ transform: 'scale(1, -1)' }}
              />
            </Box>
            <Box
              sx={{
                background: '#FFF',
                width: '40px',
                height: '40px',
                borderRadius: '10px',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                cursor: 'pointer',
              }}
              onClick={() => {
                setOpen(true);
              }}
            >
              <Icon
                icon="emojione-monotone:pencil"
                color="#424245"
                width="20px"
              />
            </Box>
            <Box
              sx={{
                background: '#FFF',
                borderRadius: '10px',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                px: '10px',
              }}
            >
              <Stack direction="row" alignItems="center" gap={1}>
                <ResetIcon />
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  איפוס סיסמה
                </Typography>
              </Stack>
            </Box>
          </Stack>
        </TableCell>
      </TableRow>
      <Edit
        open={open}
        onClose={() => {
          setOpen(!open);
        }}
        agent={agent}
      />
    </>
  );
};

export default Item;
